import React from 'react';

const STEPS = [
  {
    num: "01",
    title: "Ship Your Product",
    desc: "Send your product or existing assets. We handle everything from there."
  },
  {
    num: "02",
    title: "We Produce",
    desc: "Filming, advanced production enhancement, editing, music, voiceover — all handled in our studio."
  },
  {
    num: "03",
    title: "You Review",
    desc: "Two revision rounds included. You approve every frame."
  },
  {
    num: "04",
    title: "You Go Live",
    desc: "Final files delivered. Upload straight to Amazon."
  }
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-instrument italic text-white text-3xl md:text-5xl text-center mb-12">
          "Four steps. Seven days."
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {STEPS.map((step) => (
            <div key={step.num} className="liquid-glass rounded-2xl p-8 flex flex-col items-start border border-white/5">
              <span className="font-instrument italic text-6xl text-white/20 mb-2 block select-none">
                {step.num}
              </span>
              <h3 className="font-semibold text-white text-base font-sans mt-4">
                {step.title}
              </h3>
              <p className="text-white/60 text-sm mt-2 font-sans leading-relaxed">
                {step.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}